var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_25"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(7.037036820142356,0,0,7.636110122661658,34.83333231881261,-6.949998597447596) ",
    id: "svg_24",
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null",
    transform: "translate(8.526315689086914,7.202620029449463) translate(6.15000057220459,0) translate(0,-1.9999992847442627) "
  }, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_21"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_22",
    fill: "#c34271",
    d: "m42.676316,45.202621l-16.2,0c-3.3,0 -5.9,-2.7 -5.9,-5.9l0,-18.1c0,-0.6 0.4,-1 1,-1s1,0.4 1,1l0,18.1c0,2.2 1.8,3.9 3.9,3.9l16.2,0c2.2,0 3.9,-1.8 3.9,-3.9l0,-18.1c0,-0.6 0.4,-1 1,-1s1,0.4 1,1l0,18.1c0,3.2 -2.7,5.9 -5.9,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_20",
    fill: "#c34271",
    d: "m47.976316,10.102621l-7.6,0c-0.5,-2.8 -2.9,-4.9 -5.8,-4.9s-5.3,2.1 -5.8,4.9l-7.6,0c-2.3,0 -4.1,1.8 -4.1,4.1s1.8,4 4.1,4l26.9,0c2.3,0 4.1,-1.8 4.1,-4.1s-1.9,-4 -4.2,-4zm-13.4,-2.9c1.8,0 3.3,1.2 3.7,2.9l-7.5,0c0.5,-1.7 2,-2.9 3.8,-2.9zm13.4,9l-26.8,0c-1.1,0 -2.1,-0.9 -2.1,-2.1c0,-1.1 0.9,-2.1 2.1,-2.1l26.9,0c1.1,0 2.1,0.9 2.1,2.1c-0.1,1.2 -1,2.1 -2.2,2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_17"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_18",
    fill: "#c34271",
    d: "m27.576316,40.302621c-0.6,0 -1,-0.4 -1,-1l0,-16.7c0,-0.6 0.4,-1 1,-1s1,0.4 1,1l0,16.7c0,0.5 -0.5,1 -1,1z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_15"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_16",
    fill: "#c34271",
    d: "m41.576316,40.302621c-0.6,0 -1,-0.4 -1,-1l0,-16.7c0,-0.6 0.4,-1 1,-1s1,0.4 1,1l0,16.7c0,0.5 -0.5,1 -1,1z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_14",
    fill: "#c34271",
    d: "m34.576316,40.302621c-0.6,0 -1,-0.4 -1,-1l0,-16.7c0,-0.6 0.4,-1 1,-1s1,0.4 1,1l0,16.7c0,0.5 -0.5,1 -1,1z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.56cbb3da73c236c7c1a9deb79ba4ff7f.svg";
export { ForwardRef as ReactComponent };